import { GenericReportingService } from 'app/core/services/genericReporting.service';
import { Component, ElementRef, Injector, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Response } from '@angular/http';
import { Title } from '@angular/platform-browser';
import { CellClickedEvent, GridOptions, RowNode } from 'ag-grid';
import { PayorsService } from 'app/pages/payors/payors.service';
import { _currencyFormat, _downloadFile } from 'app/utils/trip2-query-builder/utils/helpers';
import { IMyOptions } from 'mydatepicker';
import { constant } from '../../../../app.constants';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { BooleanCheckComponent } from '../../../A2-utils/grid-components/boolean-check/boolean-check.component';
import { DateModel } from '../../../A2-utils/ParentClass/parent-class-date.model';
import { ReservationService } from '../../../trip-reservations/reservations.service';
import { DataProcessingService } from '../../data-processing.service';
import { UploadsService } from '../../../A2-utils/uploads.service';
import { CatchingErrorsService } from '../../../A2-utils/ParentClass/catching-errors.service';
import {
  assignNewArray,
  assignNewObjet,
  messagePermits,
  viewMessageAlertRider
} from '../../../A2-utils/export-functions/functions-services';
import { ITripDetail } from '../../../../core/interfaces/trip-detail.interface';
import { EnumTypeAlertRider, RiderAlertService } from '../../../rider/services/rider-alert.service';
import { Subscription } from 'rxjs/Subscription';
import { BillingEditService } from '../../../../core/services/billing-edit.service';
import { IDataBillingExport } from '../../../../core/interfaces/billing-form.interface';
import { IForms } from '../../../../core/interfaces/forms.interface';
import { IScheduleAndEvent } from '../../../../core/interfaces/billing.interface';
import { ParentModule } from '../../../A2-utils/ParentClass/parent-module';
import { empty } from 'rxjs/observable/empty';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import * as moment from 'moment';
import { IChangeBillingTrip } from '../../../../core/interfaces/change-billing-status-trips.interface';
import { TabsUnverifiedTripsEnum } from '../../../../core/enums/tabs-unverified-trips.enum';
import { ChangeBillingStatusService } from 'app/pages/A2-utils/change-billing-status-trip/change-billing-status.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import Swal from 'sweetalert2';
import { IOpenReport } from 'app/core/interfaces/IGenericReport.interface';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { BillingStatusEnum } from 'app/core/enums/billing-status.enum';
import { PayorService } from 'app/core/services/payor.service';
import { Observable } from 'rxjs/Observable';
import { AgGridSortFilterUtils } from 'app/core/ag-grid-utils/ag-grid-sort-filter-utils';
import { ReportTypeEnum } from 'app/core/enums/report-type.enum';
import { getCurrentUser, getSelectNodeAfterFilter } from 'app/utils/helpers';
import { TenantsEnum } from 'app/core/enums/tenants.enum';
import { ReportsIdEnum } from 'app/core/enums/reportsId.enum';
import { GridLayoutStore, moduleActionIdOf } from 'app/utils/grid-layout-menu/grid-layout-store';

declare const XLSX: any;
declare const $: any;

@Component({
  selector: 'app-data-processing-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss'],
  providers: [GridLayoutStore]
})
export class ExportComponent extends ParentModule implements OnInit, OnDestroy {
  optionsViewResponsive = false;
  ptrDateBegin: DateModel;
  ptrDateEnd: DateModel;
  selectedBillingStatus: any;
  showsent = false;
  showqty: null;
  tabsUnverifiedTrips = constant.UNVERIFIED_TRIPS.TABS_UNVERIFIED_TRIPS;
  forms: IForms[] = [];
  formsCtrl: IForms[] = [];
  selectedForm: number;
  claimStatus: any;
  currentUser = JSON.parse(localStorage.getItem('currentUser'));

  jsonPolicyDateFrom: any;
  jsonPolicyDateTo: any;
  myRDPOptions: IMyOptions = {
    firstDayOfWeek: 'su',
    dateFormat: 'mm-dd-yyyy',
    editableDateField: true,
    markCurrentDay: false,
  };
  toggleCalendar = 1;

  formId: number;
  tripData: any;
  gridExports: GridOptions;
  gridExportEncountersRejections: GridOptions;
  gridExportsSummaryTrips: GridOptions;
  private summaryLayoutConfig: string = null;
  gridSelected: GridOptions;
  enableClearSort = true;
  enableClearFilter = true;
  enableReload = true;
  dateRangeExport: any;
  dateReport: any;
  isOpenAppRidersCreate: boolean;
  modalExportVisible = false;
  selectedReportBtn = '';
  payorList = [];
  payorListCtrl = [];
  payorSelectedList = [];
  fileName = '';
  reservationForm: FormGroup;
  schedules: IScheduleAndEvent[] = [];
  selectedSchedule: number;
  tripsArrayIds: number[];
  resetControls: number;
  morethan50milesonly = false;
  showduplicates = false;
  billingstatusList = [];
  billingstatusId = undefined;
  rowsPerPage = 1000;
  page = 1;
  pagesTotal: number;
  totalItems: number;
  disabledBtnStatus: boolean;
  loadSelectFilterBy = [
    {
      id: 1, title: 'Select By Payor', description: 'Payor',
      order: {payor: 1, billing: 2, form: 3},
      required: {payor: true, billing: false, form: false}
    },
    {
      id: 2, title: 'Select By Schedule', description: 'Billing',
      order: {payor: 2, billing: 1, form: 3},
      required: {payor: false, billing: true, form: false}
    },
    {
      id: 3, title: 'Select By Form', description: 'Form',
      order: {payor: 2, billing: 3, form: 1},
      required: {payor: false, billing: false, form: true}
    }
  ];
  selectedFilterBy = this.loadSelectFilterBy[0];

  tripsForForm: number[] = [];
  tripsData = [];
  protected totalRows = 0;
  private clearSortSwitch = false;
  private observables: Subscription[] = [];
  private uploadFile: any;

  dataCurrentModule: any = {};
  disableBtnSaveLayout = true;
  isSelectPayorDisabled: boolean;
  isSelectFormDisabled: boolean;
  payorListId = [];
  changeDate: boolean;
  selectedExportTozoll: boolean;
  payorTypes = [];
  providerTypes = [];
  modifierList = [];
  PUModifier: null;
  DOModifier: null;
  isPuModifier = false;
  isDoModifier = false;
  // Initial value in null for selected all por default
  providerTypesId = null;
  getContextMenuItems: (params?) => void;
  getContextMenuItemsSummary: (params?) => void;
  @ViewChild('fileUpload') protected _fileUpload: ElementRef;
  @ViewChild('modalExport') modalExport: T2CardComponent;
  @ViewChild('modalReport') modalReport: T2CardComponent;
  @ViewChild('modalVerify') modalVerify: T2CardComponent; // TODO: QUITAR.
  @ViewChild('formsUpload') formsUploadCard: T2CardComponent;
  @ViewChild('formsModal') private modal837File: T2CardComponent;
  @ViewChild('formsChangeModifier') private formsChangeModifier: T2CardComponent;

  dropdownSettings = {};
  dropdownSettings2 = {};
  selectedPayorType = null;
  activePayorType = false;
  titleForExport = this.getIsAvOrClmTenant ? 'Unverified Trips' : 'Summary Trips';
  activatedTab = this.getIsAvOrClmTenant ? TabsUnverifiedTripsEnum.UnverifiedTrips : TabsUnverifiedTripsEnum.SummaryTrips;
  showInactiveCtrl = true;
  payorTypeId = undefined;
  constructor(
    protected fb: FormBuilder,
    protected service: DataProcessingService,
    protected tripService: ReservationService,
    protected _loading: T2LoadingService,
    protected vcr: ViewContainerRef,
    private uploadService: UploadsService,
    private payorService: PayorsService,
    protected catchingError: CatchingErrorsService,
    private titleService: Title,
    private loading: T2LoadingService,
    private _riderAlertService: RiderAlertService,
    private _billingEditService: BillingEditService,
    private changeBillingStatusService: ChangeBillingStatusService,
    protected Inject: Injector,
    private toastrAlertHelper: ToastrAlertHelper,
    private _serviceRepotTrip: GenericReportingService,
    private sweetAlertHelper: SweetAlertHelper,
    private payorsService: PayorService,
    private layoutStore: GridLayoutStore
    ) {
      super('app-data-processing-export', Inject);
    this.gridSelected = this.gridExports;
    this.gridExportsSummaryTrips = <GridOptions> {};
    this.gridExportEncountersRejections = <GridOptions> {};
    this.initGrids();
    this.gridExports = <GridOptions> {};
    this.gridExports.columnDefs = this.createColumn();
    this.gridExports.rowSelection = 'multiple';
    this.gridExports.enableSorting = true;
    this.gridExports.enableColResize = true;
    this.gridExports.onSortChanged = () => {
      this.afterSort();
    };
    this.sheetExportExcel();
    this.gridExports.onRowDoubleClicked = (params) => {
      this.modalExport.open();
      this.tripData = params.data;
    };
    const self = this;

    this.gridExports.onFilterChanged = (params) => {
      this.gridExports.api.deselectAll();
      this.enableClearFilter = !params.api['filterManager'].advancedFilterPresent;
      this.totalRows = self.gridExports.api.getDisplayedRowCount();
    };

    this.gridExports.onGridReady = () => {
      this.gridExports.api.setRowData([]);
    };
    this.gridExports.onCellClicked = (event: CellClickedEvent) => {
      this.showAlert(event);
    };
    this.gridExports.onSelectionChanged = () => {
      this.tripsForForm = this.getTripsIdSelected();
    };

    this.getAllClaimStatus();
    this.observables.push(this.actions.asObservable().subscribe((res) => {
      this.dataCurrentModule = res;
      this.getLayout();
    }));
  }

  get layoutGrid(): GridOptions {
    if (this.activatedTab === TabsUnverifiedTripsEnum.ElectronicSubmissions
      || this.activatedTab === TabsUnverifiedTripsEnum.Rejections) {
      return this.gridExportEncountersRejections;
    }
    if (this.activatedTab === TabsUnverifiedTripsEnum.SummaryTrips) {
      return this.gridExportsSummaryTrips;
    }
    return this.gridExports;
  }

  get layoutGridTitle(): string {
    return this.activatedTab === TabsUnverifiedTripsEnum.SummaryTrips ? 'Summary Trips' : 'Unverified Trips';
  }

  ngOnInit(): void {
    this.initLayoutMenu();
    const ON_SP$ = of({action: 'Spinner on'})
      .pipe(map((resB: any) => {
        this._loading.show();
        return resB;
      }));

    const OFF_SP$ = of({action: 'Spinner off'})
      .pipe(map((resC) => {
        this._loading.hiden();
        return resC;
      }));

    const DELAY$ = empty().pipe().delay(3000);
    const IS_ALLOWED$ = of({action: 'delay'})
      .pipe(map(() => this.disableBtnSaveLayout = !this.isAllowedAction('LayoutGrid')));

    this.observables
      .push(concat(ON_SP$, OFF_SP$, DELAY$, IS_ALLOWED$).subscribe());

    this.initFromToCtrls();
    this.initDateBeginAndEnd();
    this.getPayorsAll();
    this.getAllForms();
    this.getBillingStatuses();
    this.observables.push(
      this.service.reloadGrid$.subscribe((val: boolean) => {
        if (val) {
         this.loadDataToExportUpdate();
        }
      })
    );
    this.initService();
    this.settingDropDown();
  }

  initGrids() {
    this.initGridSummary();
    this.initAllGrids(this.gridExportEncountersRejections);
  }

  initAllGrids(gridName: GridOptions) {
    if (gridName === this.gridExportsSummaryTrips) {
      gridName.columnDefs = this.createColumnSummaryGrid();
    } else {
      gridName.columnDefs = this.createColumn();
    }
    gridName.rowSelection = 'single';
    gridName.enableSorting = true;
    gridName.enableColResize = true;
    gridName.onSortChanged = () => {
      this.afterSort();
    };
    gridName.onFilterChanged = (params) => {
      gridName.api.deselectAll();
      this.enableClearFilter =
        !params.api['filterManager'].advancedFilterPresent;
      this.totalRows = gridName.api.getDisplayedRowCount();
    };
    gridName.onRowDoubleClicked = (params) => {
      if (params && params.data && params.data.tripid) {
        this.tripData = params.data;
        this.modalExport.open();
      }
    };
    gridName.onGridReady = () => {
      gridName.api.setRowData([]);
      this.changeTitle(this.titleForExport);
    };
    gridName.onSelectionChanged = () => {
      this.tripsForForm = this.getAllTripsIdSelected(gridName);
    };
  }

  /**
   * @params {GridName}
   * @description genera los tripid selecionados despues de filtrado
  */
  getAllTripsIdSelected(gridName: GridOptions): number[] {
    const data: number[] = [];
    this.tripData = [];
    gridName.api.forEachNodeAfterFilter((node: RowNode) => {
      if (node.isSelected()) {
        data.push(node.data.tripid);
        this.tripData.push(node.data);
      }
    });
    this.tripsArrayIds = data;
    return data;
  }

  initGridSummary() {
    this.gridExportsSummaryTrips.columnDefs = this.createColumnSummaryGrid();
    this.gridExportsSummaryTrips.rowSelection = 'single';
    this.gridExportsSummaryTrips.enableSorting = true;
    this.gridExportsSummaryTrips.enableColResize = true;
    this.gridExportsSummaryTrips.onSortChanged = () => {
      this.afterSort();
    };
    const self = this;

    this.gridExportsSummaryTrips.onFilterChanged = (params) => {
      this.gridExportsSummaryTrips.api.deselectAll();
      this.enableClearFilter = !params.api['filterManager'].advancedFilterPresent;
      this.totalRows = self.gridExportsSummaryTrips.api.getDisplayedRowCount();
    };

    this.gridExportsSummaryTrips.onGridReady = () => {
      this.gridExportsSummaryTrips.api.setRowData([]);
      this.gridExportsSummaryTrips.api.sizeColumnsToFit();
      this.applySummaryLayout();
      this.changeTitle(this.titleForExport);
    };
    this.gridExportsSummaryTrips.onSelectionChanged = () => {
      this.tripsForForm = this.getTripsIdSelected();
    };
  }
  initService() {
    this.service.getPayorsType().subscribe((res) => {
      if (res) {
        this.payorTypes = res;
      }
    });

    this.service.getProviderType().subscribe((res) => {
      if (res) {
        this.providerTypes = res;
      }
    });
  }

  settingDropDown() {
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select payor',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      badgeShowLimit: 1
    };

    this.dropdownSettings2 = {
      singleSelection: true,
      text: 'Select payor',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      badgeShowLimit: 1
    };
  }

  loadDataToExportUpdate() {
    const payorsSelectedList = this.getIsAvOrClmTenant ? constant.PAYOR_DEFAULT_RIDE2MD :
      this.payorSelectedList.map((item) => item.id);

    const data = {
      payoridslist: payorsSelectedList,
      initialdate: this.ptrDateBegin,
      finaldate: this.ptrDateEnd,
      billingstatusid: [this.activatedTab],
      formid: this.formId,
      billingscheduleid: this.selectedSchedule,
      tripId: this.tripData.tripid
    };
    this.service.loadTripsToExportByTripId(data).subscribe((res) => {
      if (res && res.tripid) {
        const row = this.gridExports.api.getRowNode((res.tripid).toString());
        row.setData(res);
      }
    });
  }

  getRowNodeId = (data) => {
    if (data && data.tripid) {
      return data.tripid;
    }
  }

  onFileGenerateExcel(evt: any) {
    const ws = XLSX.utils.json_to_sheet(evt);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Uverified_trip');
    XLSX.writeFile(wb, 'Uverified_trip.xlsx');
  }

  clearSelectionPayors() {
    this.payorSelectedList = [];
  }

  clearSelectionForms() {
    this.formId = undefined;
  }

  clearSelectionBillingStatus(): void {
    this.billingstatusId = undefined;
  }

  dataToExportExcel(row: any, element?: any) {
    return {
      'Vehicle': row.data.vehiclecode,
      'Validation': row.data.Validation === undefined ? element : false,
      'Status': row.data.tripstatus,
      'Driver': row.data.drivername,
      'Rider': row.data.ridername,
      'Gender': row.data.ridergender,
      'DOB': row.data.riderdobformat,
      'Age': row.data.riderage,
      'Address': row.data.riderstreetaddress,
      'City': row.data.ridercity,
      'Zip': row.data.riderzip,
      'Country': row.data.ridercounty,
      'Region': row.data.riderregion,
      'Trip Duplicate': row.data.ishighlighted,
      'Reason For Transport': row.data.reasontransport,
      'Payor': row.data.payor,
      'Payor Authorization': row.data.payorauthorization,
      'Service': row.data.servicetype,
      'Provider': row.data.company,
      'Provider amount': row.data.provideramount,
      'Submission Date': row.data.submissiondate,
      'Paid Date': row.data.paiddate,
      'File No': row.data.edifileid,
      'File Sent Date': row.data.filesentdate,
      'Company': row.data.broker,
      'Billing Status': row.data.billingstatus,
      'Aging': row.data.aging,
      'Remarks': row.data.remarks,
      'Date': row.data.dateofservice,
      'Reservation': row.data.consecutive,
      'RescueNet': row.data.rescuenetnumber,
      'Leg': row.data.leg,
      'Appointment': row.data.appointmenttime,
      'Total amount': row.data.totalamount,
      'Millages': row.data.totalmiles,
      'Has Manual Charges': row.data.hasmanualcharges,
      'Schedule Name': row.data.schedulename,
      'Modifiers': row.data.modifiers,
      'Actual PU': row.data.actualpickup,
      'PU Time': row.data.pickup,
      'Address pickup': row.data.triplocationpickup.streetaddress,
      'City pickup': row.data.triplocationpickup.city,
      'ZipCode pickup': row.data.triplocationpickup.zip,
      'Actual DO': row.data.actualdropoff,
      'Address dropoff': row.data.triplocationdropoff.streetaddress,
      'City dropoff': row.data.triplocationdropoff.city,
      'Zipcode dropoff': row.data.triplocationdropoff.zip,
      'Last Billing User': row.data.lastbillingfullname,
      'Last Billing Date': row.data.lastdateupdated,
    };
  }

  sheetExportExcel() {
    this.getContextMenuItems = () => {
      const arrayData = [];
      return [
        {
          name: 'Export Validations Excel',
          icon: '<i class="fas fa-file-excel"></i>',
          action: () => {
            this.gridExports.api.forEachNodeAfterFilter((row) => {
              if (row.data.messagesErrorValid) {
                row.data.messagesErrorValid.forEach(element => {
                  arrayData.push(this.dataToExportExcel(row, element.description));
                });
              } else {
                arrayData.push(this.dataToExportExcel(row));
              }
            });
            this.onFileGenerateExcel(arrayData);
          }
        },
        {
          name: 'Export',
          icon: '<i class="fa fa-download"></i>',
          subMenu: [
            {
              name: 'Excel',
              icon: '<i class="fas fa-file-excel-o"></i>',
              action: () => this.gridExports.api.exportDataAsExcel({ sheetName: this.titleForExport, fileName: this.titleForExport })
            },
            {
              name: 'Csv',
              icon: '<i class="fas fa-file-csv"></i>',
              action: () => this.gridExports.api.exportDataAsCsv({ fileName: this.titleForExport })
            }
          ]
        },
        'separator',
        'copy'
      ];
    };
  }

  /**
   * @name afterSort
   * @description
   */
  afterSort() {
    if (!this.clearSortSwitch) {
      this.clearSortSwitch = true;
    } else {
      this.enableClearSort = false;
    }
  }

  /**
   * @name createColumn
   * @description
   */

  private amountCell = (params: any) => {
    return _currencyFormat(params.value ? params.value : 0);
  }

  getRowStyle(params) {
    return params.data.ishighlighted ? { background: '#dc35456b' } : null;
  }

  getValidation(params) {
    let ico = '';
    if (params.data.validations) {
      ico = 'fa-exclamation color-danger';
    }
    if (params.data.errorValid) {
      ico = 'fa-check color-success';
    }
    if (params.data.errorValid === false) {
      ico = 'fa-exclamation color-danger';
    }
    return `<i class="fa ${ico}" aria-hidden="true"></i>`;
  }

  validate(params) {
    return !(params && params.data && !params.data.validations);
  }

  private createColumn = () => [{
    allowContextMenuWithControlKey: true,
    getContextMenuItems: this.getContextMenuItems,

    headerName: '',
    width: 48,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true
  },
    {
     headerName: 'Non Duplicate',
     field: 'notduplicate',
     colId: 'notduplicate',
     width: 70,
     cellRendererFramework: BooleanCheckComponent
    },
    {
      headerName: 'Error Description',
      field: 'errordescription',
      colId: 'errordescription',
      width: 200,
      hide: false
    },
    {
      headerName: 'Error Type',
      field: 'errortype',
      colId: 'errortype',
      width: 150,
      hide: false
    },
    {
      headerName: 'Error Code',
      field: 'errorcode',
      colId: 'errorcode',
      width: 200,
      hide: false
    },
    {
      headerName: 'ICN',
      field: 'icn',
      colId: 'icn',
      width: 100,
      hide: false
    },
    {
      headerName: 'Vehicle',
      field: 'vehiclecode',
      colId: 'vehicle',
      width: 70
    }, {
      headerName: 'Validation',
      field: 'validations',
      colId: 'errorValid',
      width: 70,
      cellRenderer: this.getValidation,
      valueGetter: (params) => {
        if (params && params.data) {
        return  this.validate(params);
        }
      }
    },
    {
      headerName: 'Trip Status',
      field: 'tripstatus',
      colId: 'status',
      width: 60
    },
    {
      headerName: 'Driver',
      field: 'drivername',
      colId: 'Driver',
      width: 150
    },
    {
      headerName: 'Last Billing Change',
      children: [
        {
          headerName: 'User',
          field: 'lastbillingfullname',
          colId: 'lastbillingfullname',
          width: 80
        },
        {
          headerName: 'Date',
          field: 'lastdateupdated',
          colId: 'lastdateupdated',
          width: 50,
          cellRenderer: (params) => {
            if (params.data.lastdateupdated) {
              return moment(params.data.lastdateupdated).format('MM-DD-YYYY hh:mm');
            }
          }
        }
      ]
    },
    {
      headerName: 'Rider Information',
      children: [
      {
        headerName: 'Rider',
        field: 'ridernameformatbilling',
        colId: 'ridername',
        width: 150
      },
      {
        headerName: 'Gender',
        field: 'ridergender',
        colId: 'ridergender',
        width: 50
      },
        {
          headerName: 'Member Id',
          field: 'ridermemberid',
          colId: 'ridermemberid',
          width: 90,
          cellStyle: {textAlign: 'center'}
        },
        {
          headerName: 'DOB',
          field: 'riderdobformat',
          colId: 'riderdob',
          width: 70
        },
        {
          headerName: 'Age',
          field: 'riderage',
          colId: 'riderage',
          width: 55,
          cellStyle: {textAlign: 'right'}
        },
        {
          headerName: 'Address',
          field: 'riderstreetaddress',
          colId: 'riderstreetaddress',
          width: 180
        },
        {
          headerName: 'City',
          field: 'ridercity',
          colId: 'ridercity',
          width: 100
        },
        {
          headerName: 'Zip',
          field: 'riderzip',
          colId: 'riderzip',
          width: 50
        },
        {
          headerName: 'County',
          field: 'ridercounty',
          colId: 'ridercounty',
          width: 70
        },
        {
          headerName: 'Region',
          field: 'riderregion',
          colId: 'riderregion',
          width: 70,
          cellStyle: {textAlign: 'right'}
        },
        {
          headerName: 'Trip Duplicate',
          field: 'ishighlighted',
          colId: 'ishighlighted',
          width: 80,
          cellRendererFramework: BooleanCheckComponent
        },
      ]
    },
    {
      headerName: 'Payment Status',
      field: 'paymentstatus',
      width: 70
    },
    {
      headerName: 'R. For Transport',
      field: 'reasontransport',
      colId: 'reasontransport',
      width: 160
    },
    {
      headerName: 'Payor',
      field: 'payor',
      colId: 'payor',
      width: 80
    },
    {
      headerName: 'PU Location',
      field: 'pulocation',
      colId: 'pulocation',
      width: 100
    },
    {
      headerName: 'DO Location',
      field: 'dolocation',
      colId: 'dolocation',
      width: 100
    },
    {
      headerName: 'Payor Authorization',
      field: 'payorauthorization',
      colId: 'payorauthorization',
      width: 100
    },
    {
      headerName: 'Service',
      field: 'servicetype',
      colId: 'service',
      width: 80
    },
    {
      headerName: 'Provider',
      field: 'company',
      colId: 'company',
      width: 80
    },
    {
      headerName: 'Provider amount',
      field: 'provideramount',
      colId: 'provideramount',
      width: 100,
      cellStyle: {textAlign: 'right'},
      cellRenderer: this.amountCell
    },
    {
      headerName: 'Submission Date',
      field: 'submissiondate',
      colId: 'submissiondate',
      width: 100
    },
    {
      headerName: 'Paid Date',
      field: 'paiddate',
      colId: 'paiddate',
      width: 100
    },
    {
      headerName: 'File No',
      field: 'edifileid',
      colId: 'edifileid',
      width: 100
    },
    {
      headerName: 'File Sent Date',
      field: 'filesentdate',
      colId: 'filesentdate',
      width: 130
    },
    {
      headerName: 'Company',
      field: 'broker',
      colId: 'broker',
      width: 80
    },
    {
      headerName: 'Billing Status',
      field: 'billingstatus',
      colId: 'billingstatus',
      width: 80
    },
    {
      headerName: 'Aging',
      field: 'aging',
      colId: 'aging',
      width: 90
    },
    {
      headerName: 'Remarks',
      field: 'remarks',
      colId: 'remarks',
      width: 80
    },
    {
      headerName: 'Date',
      field: 'dateofservice',
      colId: 'date',
      width: 75
    },
    {
      headerName: 'Reservation',
      field: 'consecutive',
      colId: 'consecutive',
      width: 80
    },
    {
      headerName: 'RescueNet #',
      field: 'rescuenetnumber',
      colId: 'rescuenetnumber',
      width: 80
    },
    {
      headerName: 'Leg',
      field: 'leg',
      colId: 'leg',
      width: 50
    },
    {
      headerName: 'Appointment',
      field: 'appointmenttime',
      colId: 'appointmenttime',
      width: 80
    },
    {
      headerName: 'Total amount',
      field: 'totalamount',
      colId: 'totalamount',
      width: 100,
      cellStyle: {textAlign: 'right'},
      cellRenderer: this.amountCell
    },
    {
      headerName: 'Millages',
      field: 'totalmiles',
      colId: 'totalmiles',
      width: 100,
      cellStyle: {textAlign: 'right'},
      filterParams: AgGridSortFilterUtils.sortFilterColumn
    },
    {
      headerName: 'Has Manual Charges',
      field: 'hasmanualcharges',
      colId: 'hasmanualcharges',
      width: 90,
      cellRendererFramework: BooleanCheckComponent
    },
    {
      headerName: 'Schedule Name',
      field: 'schedulename',
      colId: 'schedulename',
      width: 90
    },
    {
      headerName: 'Modifiers',
      field: 'modifiers',
      colId: 'modifiers',
      width: 90
    },
    {
      headerName: 'Pick-Up',
      children: [{
        headerName: 'Actual PU',
        field: 'actualpickup',
        colId: 'actualpickup',
        width: 120
      },
        {
          headerName: 'PU Time',
          field: 'pickup',
          colId: 'puTime',
          width: 120
        },
        {
          headerName: 'Address',
          field: 'triplocationpickup.streetaddress',
          colId: 'puaddresss',
          width: 120
        },

        {
          headerName: 'City',
          field: 'triplocationpickup.city',
          colId: 'puCity',
          width: 120
        },
        {
          headerName: 'ZipCode',
          field: 'triplocationpickup.zip',
          colId: 'zipcodeP',
          width: 120
        },
        {
          headerName: 'Region PU',
          field: 'triplocationpickup.region',
          colId: 'triplocationpickup.region',
          width: 70
        }
      ]
    },
    {
      headerName: 'Drop-Off',
      children: [{
        headerName: 'Actual DO',
        field: 'actualdropoff',
        colId: 'actualdropoff',
        width: 120
      },
        {
          headerName: 'Address',
          field: 'triplocationdropoff.streetaddress',
          colId: 'doaddresss',
          width: 120
        },

        {
          headerName: 'City',
          field: 'triplocationdropoff.city',
          colId: 'doCity',
          width: 120
        },
        {
          headerName: 'ZipCode',
          field: 'triplocationdropoff.zip',
          colId: 'zipD',
          width: 120
        },
        {
          headerName: 'Region DO',
          field: 'triplocationdropoff.region',
          colId: 'triplocationdropoff.region',
          width: 70
        }
      ]
    }
  ]
  private createColumnSummaryGrid = () => [
    {
      headerName: 'Payor',
      field: 'payor',
      colId: 'payor',
      width: 70
    },
    {
      headerName: 'Provider Claim Status',
      children: [
        {
          headerName: 'UnBilled And UnPaid',
          field: 'unbilledandunpaid',
          colId: 'unbilledandunpaid',
          width: 25,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: 'Paid',
          field: 'paid',
          colId: 'paid',
          width: 25,
          cellStyle: { textAlign: 'right' },
        }
      ]
    },
    {
      headerName: 'Billing Client',
      children: [
         {
          headerName: 'Unverified',
          field: 'unverified',
          colId: 'unverified',
          width: 25,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: 'Pending',
          field: 'pending',
          colId: 'pending',
          width: 25,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: 'Verified',
          field: 'verified',
          colId: 'verified',
          width: 25,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: 'Billed',
          field: 'billed',
          colId: 'billed',
          width: 25,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: 'Denied',
          field: 'denied',
          colId: 'denied',
          width: 25,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: 'Close',
          field: 'close',
          colId: 'close',
          width: 25,
          cellStyle: { textAlign: 'right' },
        }
      ]
    },
  ]

  /**
   * @name dateToString
   * @description
   * @param date
   */
  private dateToString = (date) => date.year + '-' + date.month + '-' + date.day;

  /**
   * @description genera data segun tab
   */
  private generateVerified(tab: number, billingStatusId: number): number[] {
    let data: number[] = [];
    switch (tab) {
      case this.tabsUnverifiedTrips.UnverifiedTrips: {
        data = [1];
      }
        break;
      case this.tabsUnverifiedTrips.ExportZoll: {
        data = [billingStatusId];
      }
         break;
    }
    return data;
  }


  /**
   * @name loadDataToExport
   * @description
   */
  loadDataToExport(): void {
    this._loading.show();
    const begin = this.ptrDateBegin;
    const end = this.ptrDateEnd;
    const firstPayorSelectedList
      = this.getIsAvOrClmTenant ? constant.PAYOR_DEFAULT_RIDE2MD : this.payorSelectedList.map((item) => item.id)[0];
    const payorsSelectedList = this.getIsAvOrClmTenant ? constant.PAYOR_DEFAULT_RIDE2MD : this.payorSelectedList.map((item) => item.id);
    const isTenence = this.getIsAvOrClmTenant;
    // if (this.payorSelectedList.length !== 0) {

    let service: Observable<any> = null;

    switch (this.activatedTab) {
        case TabsUnverifiedTripsEnum.ElectronicSubmissions:
        case TabsUnverifiedTripsEnum.Rejections:

          const isResubmission = this.activatedTab === TabsUnverifiedTripsEnum.Rejections;

          service = this.service.dataToExportTripsECM(begin, end, firstPayorSelectedList, this.showqty, this.showsent, isResubmission);
        break;
      default:
        service = this.service.dataToExportTrips(
            begin,
            end,
            payorsSelectedList,
            this.generateVerified(this.activatedTab, this.billingstatusId),
            false,
            this.formId,
            this.selectedSchedule,
            this.morethan50milesonly,
            this.showduplicates,
            this.activatedTab,
            this.rowsPerPage,
            this.page,
            isTenence,
            this.providerTypesId ? [this.providerTypesId] : null,
          );
        break;
    }

    service.finally(() => this._loading.hiden())
      .subscribe(
        (data) => {
          if (
            data &&
            this.gridExports &&
            this.gridExports.api &&
            this.activatedTab !== this.tabsUnverifiedTrips.Rejections &&
            this.activatedTab !== this.tabsUnverifiedTrips.ElectronicSubmissions
          ) {
            this.pagesTotal = data.totalpages;
            this.page = data.page;
            this.totalItems = data.totalitems;
            const filter = this.gridExports.api.getFilterModel();
            const sort = this.gridExports.api.getSortModel();
            data.data
              ? this.gridExports.api.setRowData(data.data)
              : this.gridExports.api.setRowData(data);
            this.gridExports.api.setFilterModel(filter);
            this.gridExports.api.setSortModel(sort);
            this.totalRows = this.gridExports.api.getDisplayedRowCount();
            this.gridExports.api. getSortModel();
            const length = this.gridExports.api.getRenderedNodes().length;
            this.enableReload = length <= 0;
            this.enableClearFilter = true;
            this.enableClearSort = true;
          } else if (
            data &&
            this.gridExportEncountersRejections &&
            this.gridExportEncountersRejections.api &&
            (this.activatedTab === this.tabsUnverifiedTrips.Rejections ||
              this.activatedTab ===
                this.tabsUnverifiedTrips.ElectronicSubmissions)
          ) {
            this.dataGrid(this.gridExportEncountersRejections, data);
          }
        },
        (error) => {
          this._loading.hiden();
          this.toastrAlertHelper.error(error.message);
        }
      );
    // }
  }

  dataGrid (gridName: GridOptions, data: any) {
    this.gridSelected = gridName;
    this.pagesTotal = data.totalpages;
    this.page = data.page;
    this.totalItems = data.totalitems;
    const filter = gridName.api.getFilterModel();
    const sort = gridName.api.getSortModel();
    data.data ? gridName.api.setRowData(data.data) : gridName.api.setRowData(data);
    gridName.api.setFilterModel(filter);
    gridName.api.setSortModel(sort);
    this.totalRows = gridName.api.getDisplayedRowCount();
    gridName.api.getSortModel();

    const length = gridName.api.getRenderedNodes().length;
    this.enableReload = length <= 0;
    this.enableClearFilter = true;
    this.enableClearSort = true;
  }

  getTripsSummaryBillingClaim(){

    if(this.payorSelectedList.length == 0){
      this.toastrAlertHelper.warning('the payor field is required', 'Attention');
      return false
    }

    const ids: number[] = this.payorSelectedList.map(({ id }) => id);
    this.loading.show();
      const data = {
        start: this.getFormattedDate(this.jsonPolicyDateFrom.date),
        end: this.getFormattedDate(this.jsonPolicyDateTo.date),
        payorsIds: ids
      }
      this.observables.push(this._billingEditService.getTripsSummaryBillingClaim(data).subscribe(
        (success: any) => {
          this.loading.hiden();
          this.gridExportsSummaryTrips.api.setRowData(success);
        }, () => {
          this.loading.hiden();
        }
      ));
  }
  submitRunAction(currentTabActive: number): void {
    switch (currentTabActive) {
      case TabsUnverifiedTripsEnum.Forms:
        this.getTripsToExportBilling();
        break;
      case TabsUnverifiedTripsEnum.SummaryTrips:
        this.getTripsSummaryBillingClaim();
        break;
      default:
        this.runSendAply();
        this.loadDataToExport();
        break;
    }
  }

  runSendAply() {
    this.showduplicates = false;
    this.page = 1;
    this.disabledBtnStatus = this.billingstatusId;
  }

  /**
   * @name selectRowTrips
   * @description
   */
  public selectRowTrips(): any[] {
    const filters = [];
    this.gridExports.api.getSelectedNodes().forEach(function(data) {
      filters.push(data.data.tripid);
    });
    return filters;
  }

  /**
   * @name trips
   * @description
   */
  private trips(gridName: GridOptions) {
    const trips = [];
    gridName.api.getSelectedNodes().forEach(function(data) {
      trips.push(data.data.tripid);
    });
    return trips;
  }

  /**
   * @name exportZollData
   * @description
   */
  exportZollData(tabs?: string) {
    if (tabs === 'forms' && !this.disabledExportTozoll) {
      this.swalResponse('Error', 'You cannot perform this action', 'error');
      return;
    }

    this.sourceDataSendAlert().then((result) => {
      if (result.value) {
        this.bodyDetailsAlert('Generate Export To Zoll').then((res) => {
          if (res.value) {
            this._loading.show();
            this.service.senExportZoll(JSON.stringify(this.selectRowTrips()))
              .subscribe(success => {
                this._loading.hiden();
                this.loadDataToExport();
                this.swalResponse('Export To Zoll', success.message, 'success');
              },
                error => {
                  this._loading.hiden();
                  this.swalResponse('Export To Zoll', error.message, 'error');
                });
          }
        });
      }
    });
  }

  generate837File() {
    const selectedTrips = this.trips(this.validateGrid());
    this._loading.show('Generating File');
    if (selectedTrips.length > 0 && this.selectedForm) {

      const isSubmitions = this.activatedTab === this.tabsUnverifiedTrips.Rejections;

      this.service.generateFile837({formId: this.selectedForm, trips: selectedTrips, isResubmission: isSubmitions})
      .finally(() => this._loading.hiden())
      .subscribe({
        next: (data: Response) => {
          if (data) {
            _downloadFile(data.blob(), data.headers.get('X-Custom-Header-FileName'));
            this.modal837File.close();
          }
        },
        error: (error: any) => {
          if (error && error.headers) {
            Swal({
              title: 'Error generating file',
              text: error.headers.get('X-Custom-Header-FileName'),
              type: 'error'
            }).then();
          }
        }
      });
    }
  }

  swalResponse(title: any, text: any, type: any) {
    return Swal({
      title: title,
      text: text,
      type: type
    });
  }


  /**
   * @name saveContent
   * @description
   * @param res
   */
  private saveContent = (res: Response) => {
    const blob: Blob = res.blob();
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
  }

  /**
   * @name clearFiltersExport
   * @description clear grid filters
   */
  clearFiltersExport() {
    this.validateGrid().api.setFilterModel(null);
    this.enableClearFilter = true;
  }

  /**
   * @name clearSortExport
   * @description clear grid sort
   */
  clearSortExport() {
    this.validateGrid().api.setSortModel(null);
    this.enableClearSort = true;
  }

  /**
   * @name onDateExportSelected
   * @description
   * @param event
   */
  onDateExportSelected(event) {
    event.type === 1 ? this.ptrDateBegin = event.formatted : this.ptrDateEnd = event.formatted;
  }

  onDateExportSelectedFromTo(event: any, dateTrigger: number): void {
    event.formatted ? this.changeDate = true : this.changeDate = false;
    switch (dateTrigger) {
      case 0:
        event.formatted.trim() === '' ? this.ptrDateBegin = null : this.ptrDateBegin = event.formatted;

        if (this.jsonPolicyDateTo !== null && this.jsonPolicyDateTo !== undefined) {
          this.ptrDateEnd = this.formatDateRangeNgModel(this.jsonPolicyDateTo.date).formatedOut;
        } else {
          this.ptrDateEnd = null;
        }
        break;
      default:
        event.formatted.trim() === '' ? this.ptrDateEnd = null : this.ptrDateEnd = event.formatted;

        if (this.jsonPolicyDateFrom !== null && this.jsonPolicyDateFrom !== undefined) {
          this.ptrDateBegin = this.formatDateRangeNgModel(this.jsonPolicyDateFrom.date).formatedOut;
        } else {
          this.ptrDateBegin = null;
        }
        break;
    }
  }

  onDateExportSelectedRange(event: any): void {
    this.ptrDateBegin = this.formatDateRangeNgModel(event.beginDate).formatedOut;
    this.ptrDateEnd = this.formatDateRangeNgModel(event.endDate).formatedOut;
  }

  /**
   * @description Recalcular trips
   */
  recalculate() {
    const trips = [];
    const selected = this.gridExports.api.getSelectedRows();
    selected.map((value) => {
      trips.push(value.tripid);
    });

    if (selected.length) {
      this._loading.show();
      this.service
        .recalcualteData(trips)
        .finally(() => {
          this._loading.hiden();
        })
        .subscribe(
          (success) => {
            this.toastrAlertHelper.success(success.message);
            this.activatedTab === this.tabsUnverifiedTrips.Forms ? this.getTripsToExportBilling() : this.loadDataToExport();
          },
          (error) => {
            this.toastrAlertHelper.error(error.message);
          }
        );
    } else {
      this.toastrAlertHelper.warning('Select at least one row');
    }
  }

  /**
   * this executes when payor multiple select is changed
   * @param event event
   */
  onChangedPayorList(event) {
    this.payorSelectedList = event;
  }

  /**
   * REPORTS
   */

  /**
   * this generates TACMS Errors Report .xlsx
   */
  tacmsErrorReport() {
    if (this.dateReport) {
      this._loading.show();
      this.service.generateTacmsErrorsReport(this.dateReport.formatted).subscribe(
        report => {
          this._loading.hiden();
          const blob = report.blob();
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = 'tacmsErrors.xlsx';
          document.body.appendChild(a);
          a.click();
          this.toastrAlertHelper.success('the report file should be downloading');
          this.modalReport.close();
        },
        error => {
          this._loading.hiden();
          this.toastrAlertHelper.error(error.message);
        }
      );
    }
  }

  /**
   * THIS GENERATE DUBLICATE MODIFIER REPORT .XLSX
   */
  duplicateModifiersReport() {
    if (this.dateReport) {
      this._loading.show();
      this.service.generateDuplicateModifierReport(this.dateReport.formatted).subscribe(
        report => {
          this._loading.hiden();
          const blob = report.blob();
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = 'duplicatemodifiers.xlsx';
          document.body.appendChild(a);
          a.click();
          this.toastrAlertHelper.success('the report file should be downloading');
          this.modalReport.close();
        },
        error => {
          this._loading.hiden();
          this.toastrAlertHelper.error(error.message);
        }
      );
    }
  }

  /**
   * this executes when user change selected tab
   */
  onChangeTabs(selectedTab: TabsUnverifiedTripsEnum): void {
    this.gridSelected = this.gridExports;
    const subtractDay = moment().subtract(1, 'days');
    this.activatedTab = selectedTab;
    this.publishLayout();
    this.getBillingStatuses();
    this.toggleGridColumn(this.gridExports, ['errordescription', 'errortype', 'errorcode'], false);
    this.setPayorList(this.payorList);
    this.setFormList(this.forms);
    switch (selectedTab) {
      case TabsUnverifiedTripsEnum.SummaryTrips:
        this.changeTitle('Summary Trips');
        this.eventChangeDate();
        this.toggleCalendar = 1;
        this.selectedSchedule = undefined;
        this.billingstatusId = undefined;
        this.clearDataPaginator();
        this.applySummaryLayout();
        break;
      case TabsUnverifiedTripsEnum.UnverifiedTrips:
        this.clearSelectionForms();
        this.changeTitle('Unverified Trips');
        this.setHideColumns(false);
        this.eventChangeDate();
        this.toggleCalendar = 1;
        this.selectedSchedule = undefined;
        this.morethan50milesonly = false;
        this.showduplicates = false;
        this.clearDataPaginator();
        break;
      case TabsUnverifiedTripsEnum.ExportZoll:
        this.clearSelectionForms();
        this.getIsAvOrClmTenant ? this.changeTitle('Export to Ride2MD') : this.changeTitle('WorkFlow');
        this.setHideColumns(false);
        this.eventChangeDate();
        this.toggleCalendar = 1;
        this.selectedSchedule = undefined;
        this.billingstatusId = undefined;
        this.clearDataPaginator();
        break;
      case TabsUnverifiedTripsEnum.ElectronicSubmissions:
      case TabsUnverifiedTripsEnum.Rejections:
        this.getLayout();
        let textMessage = 'Encounters';
        if (selectedTab === TabsUnverifiedTripsEnum.Rejections) {
          textMessage = 'Rejections';
          this.payorSelectedList.splice(1, this.payorSelectedList.length);
        } else {
          this.payorTypeId = undefined;
          this.payorSelectedList = this.genericFilterArray(this.payorSelectedList, 'encounter', true, 'equal').slice(0, 1);
          this.setPayorList(this.genericFilterArray(this.payorList, 'encounter', true, 'equal'));
        }
        this.setFormList(this.genericFilterArray(this.forms, 'formtypeid', ReportTypeEnum.Encounter837, 'equal'));

        this.changeTitle(textMessage);
        this.setHideColumns(true);
        this.formId = undefined;
        this.selectedSchedule = undefined;
        this.selectedFilterBy = this.loadSelectFilterBy[0];
        if (!this.changeDate) {
          // :TODO: Fecha de inicio 7 dias antes de la fecha actual.
          const subtractSevenDays = moment().subtract(7, 'days');
          this.jsonPolicyDateFrom = {
            date: { year: subtractSevenDays.year(), month: subtractSevenDays.month() + 1, day: subtractSevenDays.date() }
          };
          this.jsonPolicyDateTo = {
            date: { year: subtractDay.year(), month: subtractDay.month() + 1, day: subtractDay.date() }
          };
          this.ptrDateBegin = this.formatDateRangeNgModel({
            day: subtractSevenDays.date(),
            month: subtractSevenDays.month() + 1,
            year: subtractSevenDays.year()
          }).formatedOut;


          this.ptrDateEnd = this.formatDateRangeNgModel({
            day: subtractDay.date(),
            month: subtractDay.month() + 1,
            year: subtractDay.year()
          }).formatedOut;

        }
        break;
      // case TabsUnverifiedTripsEnum.ECM:
      //   this.changeTitle('ECM`s');
      //   this.eventChangeDate();
      //   this.toggleCalendar = 1;
      //   break;
      case TabsUnverifiedTripsEnum.Forms:
        this.changeTitle('Forms');
        this.eventChangeDate();
        this.toggleCalendar = 1;
        this.setFormList(this.genericFilterArray(this.forms, 'formtypeid', ReportTypeEnum.Encounter837, 'diff'));
      break;
    }
    this.setGrid(this.gridExports);
    this.setGrid(this.gridExportsSummaryTrips);
    this.setGrid(this.gridExportEncountersRejections);
  }

  setGrid (gridName: GridOptions) {
    gridName.api.setRowData([]);
    gridName.api.deselectAll();
  }

  private changeTitle(message: string) {
    this.titleForExport = message;
    this.titleService.setTitle(message);
    $('#main-header .page-title').html(message);
  }

  setHideColumns(sw) {
    this.gridExports.columnApi.setColumnVisible('riderpayorisltc', sw);
  }

  /**
   * this verified selected trips
   */
  verifiedTrips() {
    this._loading.show();
    this.service.verifyTrips(this.selectRowTrips()).finally(() => {
      this._loading.hiden();
    }).subscribe(
      data => {
        this.toastrAlertHelper.success(data.message);
        this.loadDataToExport();
      },
      error => {
        this.toastrAlertHelper.error(error.message);
      }
    );
  }

  sendErrorToGrid(trips: any) {
    const updateTrips = [];
    const includeError = trips.filter((f) => !f.success).length;
    this.gridExports.api.forEachNode((row) => {
      trips.forEach((element) => {
        if (element.tripid === row.data.tripid) {
          row.data.errorValid = !element.filedarray.length;
          row.data.messagesErrorValid = element.filedarray;
        }
      });
      const data = this.activatedTab === 5 && includeError ? row.data : !row.data.errorValid;
      if (data) {
        updateTrips.push(row.data);
      }
    });
    const filter = this.gridExports.api.getFilterModel();
    const sort = this.gridExports.api.getSortModel();
    this.getContextMenuItems(updateTrips);
    this.gridExports.api.setRowData(updateTrips);
    this.gridExports.api.setFilterModel(filter);
    this.gridExports.api.setSortModel(sort);
    this.totalRows = this.gridExports.api.getDisplayedRowCount();
  }

  buildViewErrors(trips: any) {
    const tripsErrors = [];
    const tripsSuccessful = [];
    trips.forEach(element => {
      if (element.filedarray.length) {
        tripsErrors.push(element);
      } else {
        tripsSuccessful.push(element);
      }
    });
    let messages = '';
    tripsErrors.forEach(element => {
      messages +=
        `<div>
        <p><strong>
          Reservation: ${element.consecutive}
        </p></strong>`;
      element.filedarray.forEach(elem => {
        messages += `
          <p>
            ${elem.description}
          </p>
        `;
      });
      messages += `</div>`;
    });
    const message = tripsSuccessful.length > tripsErrors.length ? 'Trip Success' : 'Trips Errors';
    Swal({
      title: `<strong>${message}</strong>`,
      html: `
        <div class="color-success">Successful Trips: <strong>${tripsSuccessful.length}</strong><div>
        <div class="color-danger">
          Error Trips: <strong>${tripsErrors.length}</strong>
        <div>
        <div class="margin-t-10"><strong>Details of Fails</strong><div>
        <div class="container margin-t-10 height-200 scrollbar scrollbar-small padding-b-100">
          ${messages}
        </div>
      `,
      type: tripsSuccessful.length > tripsErrors.length ? 'success' : 'error',
      showCancelButton: false,
      confirmButtonText: 'Accept',
      cancelButtonText: 'Cancel'
    }).then();
  }

  buildViewErrors2Callback(trips: any) {
    const tripsErrors = [];
    const tripsSuccessful = [];
    trips.forEach(element => {
      if (element.filedarray.length) {
        tripsErrors.push(element);
      } else {
        tripsSuccessful.push(element);
      }
    });
    let messages = '';
    tripsErrors.forEach(element => {
      messages +=
        `<div>
        <p><strong>
          Reservation: ${element.consecutive}<br>
          Rider: ${element.rider}<br>
          Driver: ${element.driver} - ${element.driverlicense}<br>
          Vehicle: ${element.vehicle} - ${element.vehiclevin}<br>
        </p></strong>`;
      element.filedarray.forEach(elem => {
        messages += `
          <p>
            ${elem.description}
          </p>
        `;
      });
      messages += `</div>`;
    });

    Swal({
      title: '<strong>Trips Errors</strong>',
      html: `
        <div class="color-success">Successful Trips: <strong>${tripsSuccessful.length}</strong><div>
        <div class="color-danger">
          Error Trips: <strong>${tripsErrors.length}</strong>
        <div>
        <div class="margin-t-10"><strong>Details of Fails</strong><div>
        <div class="container margin-t-10 height-200 scrollbar scrollbar-small padding-b-100">
          ${messages}
        </div>
      `,
      type: 'error',
      showCancelButton: false,
      confirmButtonText: 'Accept',
      cancelButtonText: 'Cancel'
    }).then();
  }

  getNameField(field: any) {
    const fileds = {
      'actualdropoff': 'Actual dropoff',
      'actualpickup': 'Actual pickup',
      'appointmenttime': 'Appointment',
      'billingstatus': 'Billing Status',
      'billingstatusid': 'billing Statusid',
      'broker': 'Broker',
      'calltype': 'Calltype',
      'calltypeid': 'Calltype ID',
      'companions': 'Companions',
      'company': 'Company',
      'companyid': 'Company ID',
      'companyondemand': 'Company On Demand',
      'consecutive': 'Consecutive',
      'dateofservice': 'Date Of Service',
      'drivername': 'Driver Name',
      'iscoorddropoffvalid': 'Iscoorddropoffvalid',
      'iscoordpickupvalid': 'Iscoordpickupvalid',
      'ishighlighted': 'Is highlighted',
      'isridervip': 'Is Rider VIP',
      'leg': 'Leg',
      'modifierdropoffcode': 'Modifier Dropoff Code',
      'modifierdropoffid': 'Modifier Dropoff ID',
      'modifierpickupcode': 'Modifier Pickup Code',
      'modifierpickupid': 'Modifier Pickup Id',
      'payor': 'Payor',
      'payorauthorization': 'Payor Authorization',
      'payorid': 'Payor ID',
      'pickup': 'Pickup',
      'reservationid': 'Reservation ID',
      'riderage': 'Rider Age',
      'ridercity': 'Rider City',
      'riderdob': 'Rider DOB',
      'ridergender': 'Rider Gender',
      'riderid': 'Rider ID',
      'ridermemberid': 'Rider Member ID',
      'ridernameformatbilling': 'Rider Name',
      'riderstreetaddress': 'Rider Street Address',
      'ridervip': 'Rider VIP',
      'riderzip': 'Rider Zip',
      'servicetype': 'Service Type',
      'totalamount': 'Total Amount',
      'totalmiles': 'Total Miles',
      'totalrows': 'Total Rows',
      'tripconfirmed': 'Trip Confirmed',
      'tripid': 'Trip ID',
      'triplocationdropoff': 'Trip Location Dropoff',
      'triplocationpickup': 'Trip Location Pickup',
      'tripstatus': 'Trip Status',
      'tripstatusid': 'Trip Status ID',
      'vehiclecode': 'Vehicle Code'
    };

    return fileds[field] ? fileds[field] : field;
  }

  clickInCell(event: any) {
    if (event.colDef.colId === 'errorValid' && !event.data.messagesErrorValid) {
      this.service.getErrorsBytripId(event.data.tripid).subscribe((resp) => {
        if (resp) {
          return this.messageErrors(resp, 'filedarray');
        }
      });
    }
    if (event.colDef.colId === 'errorValid' && event.data.messagesErrorValid) {
      this.messageErrors(event, 'messagesErrorValid');
    }
  }

  messageErrors(event, idMessage: string) {
    let array = [];
    idMessage === 'messagesErrorValid' ? array = event.data.messagesErrorValid : array = event.filedarray;
    let messages = '';
    array.forEach(element => {
      messages += `
        <p>
          ${element.description}
        </p>
      `;
    });

    if (messages) {
      return Swal({
        title: `<strong>Reservation: ${event.consecutive ? event.consecutive : event.data.consecutive}</strong>`,
        html: `
          <div class="color-danger">
            Errors #: <strong>${array.length}</strong>
          <div>
          <div class="margin-t-10"><strong>Details of Fails</strong><div>
          <div class="container margin-t-10 height-200 scrollbar scrollbar-small padding-b-100">
            ${messages}
          </div>
        `,
        type: 'error',
        showCancelButton: false,
        confirmButtonText: 'Accept',
        cancelButtonText: 'Accept'
      }).then();
    }
  }

  /**
   * @name changeBillingStatuses
   * @description verifica y asigna lo seleccionado
   */
  changeBillingStatuses(event) {
    this.selectedBillingStatus = event.map(val => {
      return val.id;
    });
  }

  /**
   * Get All Claim Status
   * */
  private getAllClaimStatus() {
    this.service.getClaimStatus().subscribe((response: any) => {
      const value = JSON.parse(response._body);
      this.claimStatus = value.map((val) => {
        return {
          id: val.claimstatusid,
          value: val.description
        };
      });
    }, (error: any) => {
      this.toastrAlertHelper.error(error.message);
    });
  }

  private getSelectedTripsId() {
    const tripsid = [];
    this.gridExports.api.forEachNodeAfterFilter((node) => {
      if (node.isSelected()) {
        tripsid.push(node.data.tripid);
      }
    });
    return tripsid;
  }

  showSwalDialog(text, callback?) {
    Swal({
      title: 'Terms and conditions',
      html: ' <div style="text-align: justify"> <input id="confirm" type=checkbox>' + text + '</div>',
      type: 'info',

      inputValue: String(0),
      inputPlaceholder: 'You understand?',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      onOpen: () => {
        Swal.disableConfirmButton();
      }
    }).then((result) => {
      if (result.value) {
        callback();
      }
    });
    $('#confirm').change(function() {
      if (this.checked) {
        Swal.enableConfirmButton();
      } else {
        Swal.disableConfirmButton();
      }
    });
  }

  onSendToTrip2() {
    this.showSwalDialog(constant.MESSAGE_TRIP_SUBMIT, () => {
      this._loading.show();
      this.service.posSendToTrip2(this.getSelectedTripsId()).finally(() => this._loading.hiden()).subscribe((response: any) => {
        this.buildViewErrors2Callback(response);
        this.loadDataToExport();
      });
    });
  }

  loadDataToImport() {
    this.formsUploadCard.open();
  }

  public bringFileSelector() {
    this._fileUpload.nativeElement.click();
  }

  getProperties = (event) => {
    this.fileName = event.srcElement.value;
    this.uploadFile = event.srcElement.files;
  }

  sendFile() {
    if (this.fileName !== '') {
      const URL = constant.URL_IMPORT_FILE_835 + '/' + this.payorSelectedList[0].id;
      this._loading.show();
      this.toastrAlertHelper.success('Importing file');
      this.uploadService.makeFileRequest(URL, [], this.uploadFile)
        .finally(() => this._loading.hiden())
        .subscribe(
          (data) => this.validateProcess(data),
          (error) => this.toastrAlertHelper.error(this.catchingError.catchingModelState(error), '', {
              enableHTML: true
            }
          )
        );
    } else {
      this.toastrAlertHelper.warning('Please, choose a file');
    }
  }

  private validateProcess(data) {
    if (data.edifileid) {
      this.formsUploadCard.close();
      this.fileName = null;
      this.uploadFile = null;
      Swal({title: 'Successfully import!', text: data.processlogs, type: 'success'});
    }
  }

  /**
   * @description verifica si tiene alert y las llama
   */
  private showAlert(event: CellClickedEvent): void {
    if (event.colDef.field === 'hasrideralert' && event.value) {
      const data: ITripDetail = assignNewObjet(event.data);
      this.getRiderAlerts(data.riderid, data.ridername);
    }
  }

  /**
   * @description verifica si tiene alert y las llama
   */
  private getRiderAlerts(riderId: number, name: string): void {
    this.loading.show();
    this.observables.push(this._riderAlertService.getAlertRiderByTypes(riderId, EnumTypeAlertRider.Billing).subscribe(
      (success: string[]) => {
        this.loading.hiden();
        viewMessageAlertRider(success, name);
      },
      () => {
        this.loading.hiden();
      }
    ));
  }

  public getTripsToExportBilling(): void {
    if (this.formId) {
      this.loading.show();
      this.observables.push(this._billingEditService.getTripsToExportBilling(this.generateDataTripsToExport()).subscribe(
        (success: ITripDetail[]) => {
          this.loading.hiden();
          this.gridExports.api.setRowData(assignNewArray(success));
        }, () => {
          this.loading.hiden();
        }
      ));
    } else {
      this.toastrAlertHelper.info('the form field is required', 'Attention');
    }
  }

  generateDataTripsToExport(): IDataBillingExport {
    const listpayorids = this.getIsAvOrClmTenant ? constant.PAYOR_DEFAULT_RIDE2MD : this.payorSelectedList.map(f => f.id);
    return {
      billingstatusid: this.billingstatusId,
      startdate: `${this.ptrDateBegin}`,
      enddate: `${this.ptrDateEnd}`,
      formid: this.formId,
      billingscheduleid: this.selectedSchedule,
      listpayorids
    } as IDataBillingExport;
  }

  private getScheduleAndEvent(): void {
    this.observables.push(this._billingEditService.getBillingScheduleDetails().subscribe(
      (success: IScheduleAndEvent[]) => {
        this.schedules = assignNewArray(success);
      }
    ));
  }

  /**
   * @description generar form para trips seleccionados
   */
  public generateForm(): void {
    if (this.tripsForForm.length > 0) {
      if (this.isAllowedAction('Create Form')) {
        this.showBodyDetailsAlert();
      } else {
        messagePermits('Generate Form');
      }
    } else {
      Swal({title: 'Attention!', text: 'No table row selected', type: 'warning'}).then();
    }
  }

  showBodyDetailsAlert(): void {
    const BODY_REQUEST: { formId: any, tripIds: any } = { formId: null, tripIds: null};
    BODY_REQUEST.formId = this.formId;
    BODY_REQUEST.tripIds = this.tripsForForm;

    this.bodyDetailsAlert('Generate Form').then(
      (resp: any) => {
        if (resp.value) {
          this.sourceDataSendAlert().then((result) => {
            if (result.value) {
              this.execGenerateFormService(BODY_REQUEST);
              this.tripsForForm = [];
            }
          });
        }
      }
    );
  }

  execGenerateFormService(bodyRequestParam: any): void {
    this._loading.show();
    this.observables.push(
      this._billingEditService.generateFormOfTrips(bodyRequestParam)
        .finally(() => {
          this._loading.hiden();
        })
        .subscribe((data: { validationresults: any, invoicebatchid: any, invoicebatch: any }) => {
            this.sendErrorToGrid(data.validationresults);

            if (data.invoicebatchid && data.validationresults) {
              if (data.invoicebatch) {
                Swal({
                  html: `Batch Number <b>${data.invoicebatch.invoicebatchid}</b> successfully created.</br>` +
                    `Trips count <b>${data.invoicebatch.tripcount}</b></br>` +
                    `Total amount: <b>$${data.invoicebatch.totalamount}</b>`,
                  title: 'Successful Operation!',
                  type: 'success'
                }).then();
              } else {
                Swal({html: `invoicebatch property not found in server response!`, title: 'Attention!', type: 'warning'}).then();
              }
            } else {
              this.buildViewErrors(data.validationresults);
            }
          }, (error: any) => {
            Swal({title: 'Generate form of trips', text: error.message ? error.message : `Error`, type: 'error'}).then();
            this._loading.hiden();
          }
        ));
  }

  /**
   * @description genera los tripid selecionados despues de filtrado
   */
  getTripsIdSelected(): number[] {
    const data: number[] = [];
    this.tripData = [];
    this.gridExports.api.forEachNodeAfterFilter((node: RowNode) => {
      if (node.isSelected()) {
        data.push(node.data.tripid);
        this.tripData.push(node.data);
      }
    });
    this.tripsArrayIds = data;
    return data;
  }

  private publishLayout() {
    this.layoutStore.set({
      grid: this.layoutGrid,
      moduleActionId: moduleActionIdOf(this.dataCurrentModule, this.layoutActionKey()),
      title: this.layoutGridTitle,
      buttonClass: 'm-btn m-btn-secundary m-btn-circle m-btn-circle-small-medium margin margin-r-5'
    });
  }

  private layoutActionKey(): string {
    return this.activatedTab === TabsUnverifiedTripsEnum.SummaryTrips ? 'SummaryLayoutGrid' : 'LayoutGrid';
  }

  saveLayout(): void {
    const grid = this.layoutGrid;
    const MODULE_ACTION_ID = moduleActionIdOf(this.dataCurrentModule, this.layoutActionKey());
    if (grid && grid.columnApi && grid.columnApi.getColumnState().length > 0 && MODULE_ACTION_ID !== null) {
      const stringLayout = JSON.stringify(grid.columnApi.getColumnState());
      const data = {moduleactionid: MODULE_ACTION_ID, config: stringLayout};

      this.observables.push(
        this.tripService.postSaveLayout(data)
          .subscribe(() => Swal({title: 'Success!', text: 'Update your preferences to this grid', type: 'success'}).then(),
            () => Swal({title: 'Error!', text: 'error saving the layout', type: 'error'}).then())
      );
    } else {
      this.toastrAlertHelper.info('There must be at least one column to save header settings.', 'Atencion');
    }
  }

  private applySummaryLayout(): void {
    if (!this.summaryLayoutConfig || !this.gridExportsSummaryTrips || !this.gridExportsSummaryTrips.columnApi) {
      return;
    }
    this.gridExportsSummaryTrips.columnApi.setColumnState(JSON.parse(this.summaryLayoutConfig));
  }

  private getLayout(): void {
    this.observables.push(
      this.tripService.getRoleActionByModule(this.dataCurrentModule.moduleid).subscribe(
        data => {
          data.forEach((val: any) => {
            if (val.action.description === 'SummaryLayoutGrid' && val.layout) {
              this.summaryLayoutConfig = val.layout.config;
              this.applySummaryLayout();
            }
            if (val.action.description === 'LayoutGrid' && val.layout) {
              const target = this.activatedTab === TabsUnverifiedTripsEnum.SummaryTrips
                ? this.gridExports
                : this.validateGrid();
              if (target && target.columnApi) {
                target.columnApi.setColumnState(JSON.parse(val.layout.config));
              }
              if (this.activatedTab === TabsUnverifiedTripsEnum.Rejections) {
                this.toggleGridColumn(this.gridExportEncountersRejections, ['errordescription', 'errortype', 'errorcode', 'icn']);
              } else {
                this.toggleGridColumn(this.gridExportEncountersRejections, ['errordescription', 'errortype', 'errorcode', 'icn'], false);
              }
            }
          });
        }
      ));
  }

  subtractDaysFromCurrenDate(numberDays: number = 7, formatDate: string = 'MM/DD/YYYY'): { numMM: any, numDD: any, numYY: any } {
    const SUBTRACT_DAYS = moment().subtract(numberDays, 'days').format(formatDate);
    const [numMM, numDD, numYY] = SUBTRACT_DAYS.split('/');
    return {numMM, numDD, numYY};
  }

  subtractYears(numberYearsSubtract: number = 1, formatYears: string = 'YYYY'): number {
    return Number(moment().subtract(numberYearsSubtract, 'year').format(formatYears));
  }

  subtractDays(currentDay: moment.MomentInput, numberSubtractDay: number): number {
    return Number(moment(currentDay, 'DD').subtract(numberSubtractDay, 'd').format('DD'));
  }

  initFromToCtrls(): void {
    const jsonPolicyDate = moment().subtract(1, 'days');

    this.jsonPolicyDateFrom = {
      date: {
        year: this.subtractYears(),
        month: moment().month() + 1,
        day: moment().date(),
      },
    };

    this.jsonPolicyDateTo = {
      date: {
        year: jsonPolicyDate.year(),
        month: jsonPolicyDate.month() + 1,
        day: jsonPolicyDate.date(),
      },
    };
  }

  initDateBeginAndEnd(): void {
    const subtractYear = moment().subtract(1, 'year');
    const BEGIN = {
      day: subtractYear.date(),
      month: subtractYear.month() + 1,
      year: subtractYear.year(),
    }

    this.ptrDateBegin = this.formatDateRangeNgModel(BEGIN).formatedOut;

    const subtractDay = moment().subtract(1, 'days');
    const END = {
      day: subtractDay.date(),
      month: subtractDay.month() + 1,
      year: subtractDay.year(),
    };
    this.ptrDateEnd = this.formatDateRangeNgModel(END).formatedOut;
  }

  changeCalendar(...args: any[]): void {
    // if (EVENT.type === 'click') {
    const INDEX = args[1];
    const date = new Date();

    this.gridExports.api.setRowData([]);
    // LIMPIO SELECCION DE LA FECHA ANTERIOR, Y SETEO NUEVAMENTE.
    switch (INDEX) {
      case 1:
        // SETTER AL FROM TO.
        this.toggleCalendar = 1;

        // PARA TABS DIFERENTES AL ENCOUTERS
        if (this.activatedTab !== 3) {
          this.initFromToCtrls();
          this.initDateBeginAndEnd();
        } else {
          // SOLO PARA ENCOUNTERS
          const subtractSevenDays = moment().subtract(7, 'days');
          this.jsonPolicyDateFrom = {date: {year: subtractSevenDays.year(), month: subtractSevenDays.month() + 1, day: subtractSevenDays.date()}};
          this.jsonPolicyDateTo = {date: {year: date.getFullYear(), month: (moment().month() + 1), day: date.getDate()}};
          this.ptrDateBegin = this.formatDateRangeNgModel({
            day: subtractSevenDays.date(),
            month: subtractSevenDays.month() + 1,
            year: subtractSevenDays.year()
          }).formatedOut;
          this.ptrDateEnd = this.formatDateRangeNgModel({
            day: date.getDate(),
            month: (moment().month() + 1),
            year: date.getFullYear()
          }).formatedOut;
        }
        break;
      default:
        // SETTER AL DATA RANGE.
        this.toggleCalendar = 2;

        if ((this.ptrDateBegin !== null && this.ptrDateEnd !== null)) {

          let BEGIN: any = null;
          let END: any = null;

          // PARA TABS DIFERENTES AL ENCOUTERS
          if (this.activatedTab !== 3) {
            // const BEGIN = this.jsonPolicyDateFrom.date;
            // const END = this.jsonPolicyDateTo.date;
            BEGIN = this.jsonPolicyDateFrom.date;
            END = this.jsonPolicyDateTo.date;
            this.setDateRange(BEGIN, END);
          } else {

            // SOLO PARA ENCOUNTERS
            const subtractSevenDays = moment().subtract(7, 'days');
            BEGIN = {year: subtractSevenDays.year(), month: subtractSevenDays.month() + 1, day: subtractSevenDays.date()};
            END = {year: date.getFullYear(), month: (moment().month() + 1), day: date.getDate()};
          }
          this.setDateRange(BEGIN, END);

        } else {

          if (this.ptrDateBegin === null && this.ptrDateEnd === null) {
            let BEGIN_DATE_RANGE: any = null;
            let END_DATE_RANGE: any = null;
            // const BEG = { year: (date.getFullYear() - 1), month: date.getMonth(), day: date.getDate() };
            // const EN = { year: date.getFullYear(), month: date.getMonth(), day: date.getDate() };

            // PARA TABS DIFERENTES AL ENCOUTERS
            if (this.activatedTab !== 3) {
              BEGIN_DATE_RANGE = {year: this.subtractYears(), month: (moment().month() + 1), day: date.getDate()};
              END_DATE_RANGE = {year: date.getFullYear(), month: (moment().month() + 1), day: date.getDate()};
              // this.setDateRange(BEG, EN);
              this.ptrDateBegin = this.formatDateRangeNgModel(BEGIN_DATE_RANGE).formatedOut;
              this.ptrDateEnd = this.formatDateRangeNgModel(END_DATE_RANGE).formatedOut;
            } else {
              // SOLO PARA ENCOUNTERS
              const subtractSevenDays = moment().subtract(7, 'days');
              BEGIN_DATE_RANGE = {year: subtractSevenDays.year(), month: subtractSevenDays.month() + 1, day: subtractSevenDays.date()};
              END_DATE_RANGE = {year: date.getFullYear(), month: (moment().month() + 1), day: date.getDate()};

              this.ptrDateBegin = this.formatDateRangeNgModel(BEGIN_DATE_RANGE).formatedOut;
              this.ptrDateEnd = this.formatDateRangeNgModel(END_DATE_RANGE).formatedOut;
            }

            this.setDateRange(BEGIN_DATE_RANGE, END_DATE_RANGE);

          } else {

            if (this.ptrDateEnd === null) {
              // const EN = { year: date.getFullYear(), month: date.getMonth(), day: date.getDate() };
              const EN = {year: date.getFullYear(), month: (moment().month() + 1), day: date.getDate()};
              this.setDateRange(this.jsonPolicyDateFrom.date, EN);
              this.ptrDateEnd = this.formatDateRangeNgModel(EN).formatedOut;
            }

            if (this.ptrDateBegin === null) {
              // const BEG = { year: 2016, month: 1, day: 1 };

              // PARA TABS DIFERENTES AL ENCOUTERS
              if (this.activatedTab !== 3) {
                const BEG = {year: this.subtractYears(), month: (moment().month() + 1), day: date.getDate()};
                this.setDateRange(BEG, this.jsonPolicyDateTo.date);
                this.ptrDateBegin = this.formatDateRangeNgModel(BEG).formatedOut;
              } else {
                // SOLO PARA ENCOUNTERS
                const subtractSevenDays = moment().subtract(7, 'days');
                const BEG = {year: subtractSevenDays.year(), month: subtractSevenDays.month() + 1, day: subtractSevenDays.date()};
                this.ptrDateBegin = this.formatDateRangeNgModel(BEG).formatedOut;
              }
            }

          }
        }
        break;
    }
    // }
  }

  setDateRange(...args: any[]): void {
    const [INIT_DATE, END_DATE] = args;
    this.dateRangeExport = {
      beginDate: {year: INIT_DATE.year, month: INIT_DATE.month, day: INIT_DATE.day},
      endDate: {year: END_DATE.year, month: END_DATE.month, day: END_DATE.day}
    };
  }

  formatDateRangeNgModel(dateRange: { day: any, month: any, year: any }): { formatedOut: any } {
    const newDate = dateRange.month + '/' + dateRange.day + '/' + dateRange.year;
    return {formatedOut: moment(newDate).format('MM/DD/YYYY')};
  }

  isValidBtn(): boolean {
    let isValid = false;
    if (
      ((this.jsonPolicyDateFrom === null || this.jsonPolicyDateTo === null || this.payorSelectedList.length === 0) &&
        this.toggleCalendar === 1 && this.activatedTab !== this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 1) ||
      ((!this.dateRangeExport || this.payorSelectedList.length === 0) && this.toggleCalendar === 2 &&
        this.activatedTab !== this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 1)

      ||

      ((this.jsonPolicyDateFrom === null
          || this.jsonPolicyDateTo === null
          || this.payorSelectedList.length === 0
          || this.formId === undefined) &&
        this.toggleCalendar === 1 && this.activatedTab === this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 1) ||
      ((!this.dateRangeExport || this.payorSelectedList.length === 0 || this.formId === undefined) && this.toggleCalendar === 2 &&
        this.activatedTab === this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 1)

      ||

      ((this.jsonPolicyDateFrom === null || this.jsonPolicyDateTo === null || this.selectedSchedule === undefined) &&
        this.toggleCalendar === 1 && this.activatedTab !== this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 2) ||
      ((!this.dateRangeExport || this.selectedSchedule === undefined) && this.toggleCalendar === 2 &&
        this.activatedTab !== this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 2)

      ||

      ((this.jsonPolicyDateFrom === null
          || this.jsonPolicyDateTo === null
          || this.selectedSchedule === undefined
          || this.formId === undefined) &&
        this.toggleCalendar === 1 && this.activatedTab === this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 2) ||
      ((!this.dateRangeExport || this.selectedSchedule === undefined || this.formId === undefined) && this.toggleCalendar === 2 &&
        this.activatedTab === this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 2)

      ||

      ((this.jsonPolicyDateFrom === null || this.jsonPolicyDateTo === null || this.formId === undefined) &&
        this.toggleCalendar === 1 && this.activatedTab !== this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 3) ||
      ((!this.dateRangeExport || this.formId === undefined) && this.toggleCalendar === 2 &&
        this.activatedTab !== this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 3)

      ||

      ((this.jsonPolicyDateFrom === null || this.jsonPolicyDateTo === null || this.formId === undefined) &&
        this.toggleCalendar === 1 && this.activatedTab === this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 3) ||
      ((!this.dateRangeExport || this.formId === undefined) && this.toggleCalendar === 2 &&
        this.activatedTab === this.tabsUnverifiedTrips.Forms && this.selectedFilterBy.id === 3)
    ) {
      isValid = true;
    }

    return isValid;
  }

  getPayorsAll() {
    this.payorService.getPayorsActiveInactive(this.showInactiveCtrl)
      .subscribe((data) => {
        if (data && data.length) {
          this.initPayorList(data);
        }
      }, (er: any) => this.toastrAlertHelper.error(er.message));
  }

  getAllForms() {
    this.service.getAllForms().subscribe(data => {
      if (data && data.length) {
        this.forms = data;
      }
    });
  }

  getBillingStatuses(): void {
    this.service.getBillingStatuses().subscribe({
      next: (res: any) => {
        const array = res.filter( (row: any) => row.billingstatusid !== 1 );
        this.customOrderStatusList(array);
      },
      error: (err) => {
        this.loading.hiden();
        this.toastrAlertHelper.error(err);
      }
    });
  }

  customOrderStatusList(array) {
    const statusPriority = [
      BillingStatusEnum.Rejected,
      BillingStatusEnum.Pending,
      BillingStatusEnum.Verified,
      BillingStatusEnum.Refund,
      BillingStatusEnum.Closed,
      BillingStatusEnum.Denied,
    ];

    const isFormsTab = this.activatedTab === TabsUnverifiedTripsEnum.Forms;
    const visibleStatuses = isFormsTab
      ? [BillingStatusEnum.Denied, BillingStatusEnum.Verified]
      : statusPriority.filter((s) => s !== BillingStatusEnum.Denied);

    this.billingstatusList = array
      .filter((item) => {
        const id = item.billingstatusid;

        if (!visibleStatuses.includes(id)) {
          return false;
        }

        if (id === BillingStatusEnum.Closed) {
          return this.isAllowedAction('ViewStatusClosed');
        }

        return true;
      })
      .sort(
        (a, b) =>
          statusPriority.indexOf(a.billingstatusid) -
          statusPriority.indexOf(b.billingstatusid),
      );
  }

  onShowInactivePayors(isActive: boolean) {
    this.activePayorType = isActive;
    this.listPayorType(isActive);
  }

  listPayorType(isActive: boolean) {
    this.payorsService.getTypePayorsInactive(this.selectedPayorType, isActive).subscribe({
      next: (data) => {
        if (data && data.length) {
          if (this.activatedTab === TabsUnverifiedTripsEnum.ElectronicSubmissions) {
            const listPayorByType = this.mapListPayors(data);
            this.setPayorList(this.genericFilterArray(listPayorByType, 'encounter', true, 'equal'));
            this.payorList = listPayorByType;
          } else {
            this.initPayorList(data);
          }
        } else {
          this.setPayorList([]);
        }
        this.clearSelectionPayors();
      },
      error: (err) => {
        this.toastrAlertHelper.error(err);
      }
    });
  }

  mapListPayors(data: any[]): { id: number, itemName: string, encounter: boolean}[] {
    return data.length ? data.map((p: any) => ({id: p.payorid, itemName: p.description, encounter: p.encounter})) : [];
  }

  catchEvent(event: IChangeBillingTrip): void {
    this.modalVerify.close();

    if (!event.btnClickClose) {
      if (event.successRequest) {
        this.sendErrorToGrid(event.response);
        this.buildViewErrors(event.response);
      }
    }
  }

  openModalNextBillingStatus(): void {
    if (this.isAllowedAction('ChangeBillingStatus')) {
      this.modalVerify.open();
    }
  }

  resetFormControls(): void {
    this.resetControls = new Date().getTime();
  }

  validateTripsToExport(id: number, description?: string) {
    if (id === BillingStatusEnum.Rejected || id === BillingStatusEnum.Pending || id === BillingStatusEnum.Unverified) {
      this.sweetAlertHelper.createCustomAlert({
        title: description,
        html: `<input id="note" type="text" class="swal2-input" ><div><b>Note</b></div>`,
        type: 'info',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          if (!$('#note').val()) {
            Swal.showValidationMessage(`Note Is Required`);
          }
        }
      }).then((opt) => {
        if (opt.value) {
          this.sendChangeBillingStatus(id, $('#note').val());
        }
      });
    } else {
      if (id === BillingStatusEnum.Verified) {
        this.sourceDataSendAlert().then((result) => {
          if (result.value) {
            this.bodyDetailsAlert('Verify').then((res) => {
              if (res.value) {
                this.sendChangeBillingStatus(id, '');
              }
            });
          }
        });
      }
    }
  }

  sendChangeBillingStatus(id: number, note: string) {
    const data = { billingstatusid: id, note: note ? note : '', tripstochange: this.selectRowTrips() };
    this._loading.show();
    this.changeBillingStatusService
      .changeBillingStatusTrip(data)
      .finally(() => {
        this._loading.hiden();
      }).subscribe(
        success => {
          this.sendErrorToGrid(success);
          this.buildViewErrors(success);
        },
        error => {
          Swal({
            title: 'Error',
            type: 'error',
            text: error.message
          });
        }
      );
  }

  eventChangeDate() {
    if (!this.changeDate) {
      this.initFromToCtrls();
      this.initDateBeginAndEnd();
    }
  }

  changeForms(id) {
    const obj = this.forms.find(f => f.formid === id);
    this.selectedExportTozoll = obj.description.replace(/ /g, '').toLocaleLowerCase() === 'exporttozoll';
  }

  get disabledExportTozoll(): boolean {
    return this.selectedExportTozoll && this.gridExports.api.getSelectedRows().length > 0 && this.isAllowedAction('Export To Zoll');
  }

  bodyDetailsAlert(title, BODY_REQUEST?) {
    const scheduleName = [];
    const payor = [];
    let totalAmount = 0;
    if (this.tripData.length === undefined && this.tripData.tripid) {
      const auxArray = [];
      auxArray.push(this.tripData);
      this.tripData = auxArray;
    }
    this.tripData.map((item) => {
      totalAmount += item.totalamount;
      if (!scheduleName.includes(item.schedulename)) {
        scheduleName.push(item.schedulename);
      }
      if (!payor.includes(item.payor)) {
        payor.push(item.payor);
      }
    });

    return Swal(
      {
        title: title,
        html: ` <div class="container margin-t-10 height-250 scrollbar scrollbar-small">
                  <h4>Selected Trips: </h4> ${this.tripsForForm.length}
                  <h4>Schedule Name: </h4>
                  <div class="container scrollbar scrollbar-small">
                    ${scheduleName.filter((item) => item).join('<br>')}
                  </div>
                  <h4>Grand Total Amount: </h4> $${totalAmount.toFixed(2)}
                  <h4>Payors: </h4>
                  <div class="container height="auto" scrollbar scrollbar-small">
                    ${payor.filter((item) => item).join('<br>')}
                  </div>
                </div>
                `,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonColor: '#d33',
      }
    );
  }

  sourceDataSendAlert() {
    return Swal({
      title: 'Are you sure to perform this action?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok'
    });
  }

  generateReportTrips(idReport: ReportsIdEnum) {
    if (this.jsonPolicyDateFrom && this.jsonPolicyDateTo && this.payorSelectedList.length) {
      const obj: any = {
        DateOfService: [this.getFormattedDate(this.jsonPolicyDateFrom.date), this.getFormattedDate(this.jsonPolicyDateTo.date)],
        PayorId: this.payorSelectedList.map((item) => { return String(item.id); })
      };
      const modelGenericReport: IOpenReport = {
        numberReport: idReport,
        bodyRequestReport: {
          parameters: obj
        }
      };
      this._serviceRepotTrip.openGenericReport(modelGenericReport);
    }
  }

  getFormattedDate(date: any) {
    const newDate = `${date.month}-${date.day}-${date.year}`;
    return moment(newDate).format('MM-DD-YYYY');
  }

  get disableBtnTripDuplicate(): boolean {
    return !this.jsonPolicyDateFrom || !this.jsonPolicyDateTo || !this.payorSelectedList.length;
  }

  get disabledBtnRun(): boolean {
    return this.activatedTab === TabsUnverifiedTripsEnum.ExportZoll ? this.billingstatusId : true;
  }

  onRowPerPage() {
    this.page = 1;
    this.loadDataToExport();
  }

  nexPage(paginationSum: boolean) {
    paginationSum ? this.page += 1 : this.page = this.pagesTotal;
    this.loadDataToExport();
  }

  previusPage(paginationRest) {
    !paginationRest ? this.page -= 1 : this.page = 1;
    this.loadDataToExport();
  }

  duplicateModifiers() {
    this.showduplicates = true;
    this.loadDataToExport();
  }

  clearDataPaginator() {
    this.rowsPerPage = 1000;
    this.pagesTotal = 0;
    this.totalItems = 0;
    this.billingstatusId = undefined;
  }

  get showIsUnverifiedWorkFlowTabs(): boolean {
    return this.activatedTab === this.tabsUnverifiedTrips.ExportZoll || this.activatedTab === this.tabsUnverifiedTrips.UnverifiedTrips;
  }

  onTypePayorInactive(event: any) {
    this.selectedPayorType = event;
    this.listPayorType(this.activePayorType);
  }

  get disabledPaginator(): boolean {
    if (!this.getIsAvOrClmTenant) {
      if (this.activatedTab === this.tabsUnverifiedTrips.UnverifiedTrips) {
        return this.payorSelectedList.length ? false : true;
      }
      if (this.activatedTab === this.tabsUnverifiedTrips.ExportZoll) {
        return !this.payorSelectedList.length || !this.billingstatusId;
      }
    } else {
      if (this.activatedTab === this.tabsUnverifiedTrips.ExportZoll) {
        return !this.billingstatusId;
      }
    }
  }

  get isTabsUnverifiedWorkFlo(): boolean {
    return !this.getIsAvOrClmTenant &&
      (this.activatedTab !== this.tabsUnverifiedTrips.Forms && this.activatedTab !== this.tabsUnverifiedTrips.ElectronicSubmissions
        && this.activatedTab !== this.tabsUnverifiedTrips.Rejections);
  }

  get toogleShowQtyIAndShowSentI(): boolean {
    return (this.activatedTab === this.tabsUnverifiedTrips.ElectronicSubmissions ||
            this.activatedTab === this.tabsUnverifiedTrips.Rejections);
  }

  get toggleBtnRunI(): boolean {
    return (this.activatedTab !== this.tabsUnverifiedTrips.Forms &&
            this.activatedTab !== this.tabsUnverifiedTrips.ElectronicSubmissions &&
            this.activatedTab !== this.tabsUnverifiedTrips.Rejections);
  }

  get getStringTitle(): string {
    return this.activatedTab === this.tabsUnverifiedTrips.Rejections ? 'Generate 837 File Rejection' : 'Generate 837 File';
  }

  get toogleBtnDownLoadFormatAndPayorMultiSelect(): boolean {
    return (this.activatedTab === this.tabsUnverifiedTrips.ElectronicSubmissions ||
            this.activatedTab === this.tabsUnverifiedTrips.Rejections);
  }

  get toogleEncountersAndRejectionsTab(): boolean {
    return (this.activatedTab !== this.tabsUnverifiedTrips.ElectronicSubmissions &&
            this.activatedTab !== this.tabsUnverifiedTrips.Rejections);
  }

  get toggleSpanClearSelection(): boolean {
    return (this.activatedTab !== this.tabsUnverifiedTrips.ElectronicSubmissions &&
            this.activatedTab !== this.tabsUnverifiedTrips.Rejections)
            && this.payorSelectedList.length > 0;
  }

  toggleGridColumn(gridName: GridOptions, nombreColumna: string[], visible = true): void {
    gridName.columnApi.setColumnsVisible(nombreColumna, visible);
  }

  validateGrid(): GridOptions {
    switch (this.activatedTab) {
      case TabsUnverifiedTripsEnum.ElectronicSubmissions:
      case TabsUnverifiedTripsEnum.Rejections:
        this.gridSelected = this.gridExportEncountersRejections;
        break;
      default:
        this.gridSelected = this.gridExports;
        break;
    }
    return this.gridSelected;
  }

  initPayorList(data: any[]): void {
    this.clearSelectionPayors();
    const mappedList = this.mapListPayors(data);
    this.setPayorList(mappedList);
    this.payorList = mappedList;
  }

  setPayorList(list: any[]): void {
    this.payorListCtrl = list;
  }

  setFormList(list: any[]): void {
    this.formsCtrl = list;
  }

  genericFilterArray(arrayList: any[], itemArray: string, validator: any, logicalOperator: ('equal' | 'diff' | 'all')): any[] {
    if (arrayList.length) {
      switch (logicalOperator) {
        case 'equal':
          return arrayList.filter((f: any) => f[itemArray] === validator);
        case 'diff':
          return arrayList.filter((f: any) => f[itemArray] !== validator);
        default:
          return arrayList;
      }
    } else {
      return [];
    }
  }

  setNonDuplicate() {
    this.sweetAlertHelper
      .createCustomAlert({
        title: 'Are you sure?',
        text: 'You will not be able to revert this!',
        type: 'warning',
        showCancelButton: true,
      })
      .then((result) => {
        if (
          result &&
          result.value &&
          this.gridSelected &&
          this.gridSelected.api.getSelectedRows().length
        ) {
          this._loading.show();
          const tripList = [];
          tripList.push(
            ...this.gridSelected.api
              .getSelectedRows()
              .map((row: any) => row.tripid)
          );
          if (tripList && tripList.length) {
            this.observables.push(
              this.service.setNonDuplicate(tripList)
              .finally(() => {
                this._loading.hiden();
              })
              .subscribe({
                next: () => {
                  this.sweetAlertHelper.createCustomAlert({
                    title: 'Success',
                    text: 'Non duplicate has changed status',
                    type: 'success',
                  });
                  this.loadDataToExport();
                },
                error: (err) => {
                  this.sweetAlertHelper.captureException(err);
                },
              })
            );
          }
        }
      });
  }

  get isTrip2Tenant(): boolean {
    return getCurrentUser().tenant === TenantsEnum.trip2;
  }

  openModalChangeModifier() {
    this.formsChangeModifier.open();
    const selectedRows = getSelectNodeAfterFilter(this.gridSelected);
    const tripIds = selectedRows.map((row) => row.tripid);
    this.service.tripIdList.next(tripIds);
    this.service.closeModal.next(false);
    this.observables.push(
      this.service.closeModal$.subscribe({
        next: (value) => {
          if (value) {
            this.closeModalChangeModifier();
          }
        },
      })
    );
  }

  closeModalChangeModifier() {
    this.formsChangeModifier.close();
  }

  get isTabWorkflow(): boolean {
    return this.activatedTab === this.tabsUnverifiedTrips.ExportZoll;
  }

  get getSelectedGrid(): boolean {
    return getSelectNodeAfterFilter(this.gridSelected).length > 0 ;
  }

  get getIsAvOrClmTenant(): boolean {
    return (
      this.currentUser &&
      this.currentUser.tenant &&
      [TenantsEnum.clm, TenantsEnum.av].some((tenant) =>
        this.currentUser.tenant.includes(tenant),
      )
    );
  }

  private initLayoutMenu() {
    this.observables.push(this.actionsList$.subscribe({ next: () => this.publishLayout() }));
  }

  ngOnDestroy(): void {
    this.service.getReloadGrid(false);
    this.observables.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/data-processing/components/export/export.component.ts